import request from "../Requests/requests";
import { clearCart } from "../store/removedTodosReducer";

export const getClearCart = () => {
    return async dispatch => {
        try {
            const response = await request.delete('/Task/ClearCart', {params: {
                UserId: localStorage.getItem('userID'), 
            }})
            .then(() => dispatch(clearCart(0)))
            const data = response.data
            return data 
        } catch (error) {
            return error
        }
    }
}